module.exports = __webpack_public_path__ + "assets/img/3_1247.9f7ffaf4.jpg";